/**
 * Optical-flow-to-grid fragment shader.
 *
 * @todo Center the flow and cover the grid/screen.
 */

#ifdef GL_EXT_draw_buffers
  #extension GL_EXT_draw_buffers : require
#endif

precision highp float;

#if defined(grid_output_motionFull)
  uniform vec2 rescaleFlow;
  uniform sampler2D opticalFlow;
  uniform float dt;

  #ifdef rescale_motion
    uniform vec2 rescaleMotion;
  #else
    const float rescaledMotion = 1.0;
  #endif
#endif

varying vec2 opticalFlowToGrid_uv;

#ifdef grid_output_motionFull
  #pragma glslify: exponent = require(../../src/vector/exponent);
#endif

void main() {
  #ifdef grid_output_motionFull
    #ifdef rescale_motion
      float rescaledMotion = exponent(rescaleMotion);
    #endif

    float rescaledFlow = exponent(rescaleFlow);
    vec2 flow = dt*texture2D(opticalFlow, opticalFlowToGrid_uv).xy*rescaledFlow;

    grid_output_motionFull = flow/rescaledMotion;
  #endif
}
